export const COUPON_INFO_BYCODE = {
  name: '根据券码查询券实例、券流水信息及券信息',
  api: '${BASE}/bcp-coupon-dev/api/B/couponInstance/infoByQrCode',
  doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378610',
};
export const SEARCH_MEMBER_DETAIL = {
  name: '获取会员详情',
  api: '${BASE}/bcp-crm-dev/api/B/external/customer/info',
  method: "get",
  doc: "http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378308"
};
export const COUPON_BYCID_LIST = {
  name: '查询退券列表接口',
  api: '${BASE}/bcp-coupon-dev/api/B/writeOffQuery/listByCidAndBid',
  method: "post",
  doc: "http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378319"
};
export const COUPON_RETREAT = {
  name: '退券',
  api: '${BASE}/bcp-coupon-dev/api/B/instanceWriteOff/returnWriteoff',
  method: "post",
  doc: "http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378322"
};
